var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-4 primary"},[_c('v-progress-linear',{attrs:{"indeterminate":"","color":"white"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }